// TOP LEVEL IMPORTS
import React from 'react';
import { ThemeProvider } from 'styled-components';
// LIB
import theme from 'lib/theme';
// APOLLO
import client from 'ApolloClient';
import { ApolloProvider } from 'react-apollo';

// COMPONENTS
import AppRoutes from 'routes';

class App extends React.Component {
  componentDidMount() {
    window.mixpanel.track('Page Loaded');
    window.Sentry.init({ dsn: 'https://6fb5b3abfa7a499595cd8fe9fb327a98@sentry.io/1371499' });
  }

  render() {
    return (
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <AppRoutes theme={theme} />
        </ThemeProvider>
      </ApolloProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js